import { api } from './baseUrl';

const videoService = {
  /**
   * Générer un texte/scénario à partir d'un prompt
   * @param {string} prompt
   * @returns {Promise<{ script: string, tags: string[] }>}
   */
  async generateScript(prompt) {
    const response = await api.post("/video/generate-script", { prompt });
    return response.data;
  },

  /**
   * Chercher des vidéos Pixabay en fonction d'un texte/thème
   * @param {string} theme
   * @param {number} count
   * @returns {Promise<Array<{ url: string, preview: string }>>}
   */
  async searchPixabayVideos(theme, count = 6) {
    const response = await api.get(
      `/video/pixabay-search?theme=${encodeURIComponent(theme)}&count=${count}`,
    );
    return response.data;
  },

  /**
   * Générer une vidéo à partir d'un script et d'une sélection de vidéos
   * @param {string} script
   * @param {Array<string>} videoUrls
   * @returns {Promise<{ videoUrl: string, description: string, tags: string[] }>}
   */
  async generateVideoFromSelection(script, videoUrls, subject = "") {
    const response = await api.post("/video/generate-from-selection", {
      script,
      videoUrls,
      subject,
    });
    return response.data;
  },

  async getHistory() {
    const response = await api.get("/video/history");
    return response.data;
  },

  async deleteVideo(id) {
    const response = await api.delete(`/video/${id}`);
    return response.data;
  },
};

export default videoService;
